let _events = [];
let _init = {};
const observableEvents = new Rx.BehaviorSubject(_events);

/**
 * @ngdoc service
 * @name repositories.EventsRepository
 *
 * @description
 * This class is used to get events objects.
 */
const EventsRepository = {

    /**
     * @ngdoc function
     * @name repositories.EventsRepository#getAll
     * @methodOf repositories.EventsRepository
     * @function
     *
     * @description
     * This function can be used to retrieves all events from repository.
     *
     * @returns {Array} events all events from repository
     */
    getAll() {

        return _events;

    },

    /**
     * @ngdoc function
     * @name repositories.EventsRepository#add
     * @methodOf repositories.EventsRepository
     * @function
     *
     * @description
     * This function can be used to add a new event to repository.
     *
     * @param {object} event An event object.
     */
    add(event) {

        const indexOfEvent = _events.findIndex(_event => String(_event.id) === String(event.id));

        if (indexOfEvent === -1) {

            _events.unshift(event);
            observableEvents.onNext(_events);

        }

    },

    /**
     * @ngdoc function
     * @name repositories.EventsRepository#replace
     * @methodOf repositories.EventsRepository
     * @function
     *
     * @description
     * This function can be used to replace all stored events with provided data.
     *
     * @param {Array} data An array with new events.
     */
    replace(data, deviceId) {

        _events = data;
        _init = { [deviceId]: true };
        observableEvents.onNext(_events);

    },

    /**
     * @ngdoc function
     * @name repositories.EventsRepository#getObservable
     * @methodOf repositories.EventsRepository
     * @function
     *
     * @description
     * This function can be used to get an observable object for events repository.
     * @returns {Object} an observable object for events repository.
     */
    getObservable() {

        return observableEvents;

    },

    /**
     * @ngdoc function
     * @name repositories.EventsRepository#getInitState
     * @methodOf repositories.EventsRepository
     * @function
     *
     * @description
     * This function can be used to get the state of the events repository
     * in order to make the call to the rest service only once
     * @returns {Object} an observable object for events repository.
     */
    getInitState(deviceId) {

        return _init[deviceId];

    },

};

export default EventsRepository;



// WEBPACK FOOTER //
// ./scripts/common/repositories/-RFC.eventsRepository.js